<template>
	<div class="card-head">
		<div class="head-left">
			<img class="head-icon" src="../../../../assets/yq/fold/circle.png" alt="">
			<span class="head-title">{{title}}</span>
			<div class="line"></div>
			<img class="head-arrow" src="../../../../assets/yq/fold/decoration.png" alt="">

		</div>



	</div>
</template>

<script>
	export default {

		props: {
			title: {
				type: String,
				default: '',
			},


		},
		data() {
			return {

			};
		},
		async created() {

		},

		methods: {



		},
	};
</script>
<style lang="scss" scoped>
	.card-head {
		height: 0.39rem;
		margin-top: 0.3rem;
		margin-bottom: 0.2rem;
		
		width: 100%;
		
		padding-left: 0.26rem;
		display: flex;
		justify-content: space-between;

		.head-left {
			display: flex;
			align-items: center;
		}

		.head-icon {
			width: 0.3rem;
			height: 0.3rem;
			// margin-left: 0.19rem;
		}

		.head-title {
			font-size: 0.25rem;
			font-family: Source Han Sans CN-Regular, Source Han Sans CN;
			font-weight: 400;
			color: #00FEFF;
			margin: 0 0.15rem;
		}

		.line{
			width: 1.59rem;
			height: 0rem;
			opacity: 0.3;
			border: 0.01rem solid #00FEFF;
			margin-right: 0.05rem;
		}
	}


</style>